// Hook partagé : fetch sécurisé avec auth Bearer + cookie + tenant.
// Tous les widgets Finance l'utilisent. credentials:"include" + Bearer
// (le backend accepte les deux schémas d'auth, cf. AuthContext).
import { useEffect, useState } from "react";
import { tenantResolu } from "../../utils/tenantResolu";
import { enteteTenant } from "../../utils/enteteTenant";

const API = process.env.REACT_APP_BACKEND_URL;

const getTenant = tenantResolu;

export function useFinanceFetch(url, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!url) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    // Sans tenant résolu : AUCUNE requête, état vide explicite (jamais de repli sur un tenant nommé).
    const tenant = getTenant();
    if (!tenant) { setData(null); setError(null); setLoading(false); return () => { cancelled = true; }; }
    const token = localStorage.getItem("session_token");
    const headers = {
      ...enteteTenant(tenant),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
    fetch(`${API}${url}`, { headers, credentials: "include" })
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then((d) => { if (!cancelled) setData(d); })
      .catch((e) => { if (!cancelled) setError(String(e.message || e)); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, deps);

  return { data, loading, error };
}

// Helper formattage € (FR)
export function formatEuro(value, { compact = false } = {}) {
  const n = Number(value || 0);
  if (compact && Math.abs(n) >= 1000) {
    return `${(n / 1000).toFixed(n >= 10000 ? 0 : 1)}k €`;
  }
  return n.toLocaleString("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });
}
